import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseAuthService } from '../../services/firebase/firebase-auth.service';
import { environment } from '../../../environments/environment';
import { FormGroup, FormControl } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { flatMap } from 'rxjs/operators';

@Component({
  selector: 'app-registro-usuario',
  templateUrl: './registro-usuario.component.html',
  styleUrls: ['./registro-usuario.component.css']
})
export class RegistroUsuarioComponent implements OnInit {

  public user = [];
  public existsEmail;
  public isAlert = false;
  public showAlert = false;

  loginForm = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });


  constructor(private authSvc: FirebaseAuthService, private router: Router, private firestore: AngularFirestore) { }

  ngOnInit(): void {
    this.existsEmail = false;
  }


  async onRegister() {
    try {
      const { email, password } = this.loginForm.value;
      if (password.length < 6) {
        this.showAlert = true;
      } else {
        const snapshotResult = this.firestore.collection('/Administradores', ref =>
          ref.where('email', '==', email))
          .snapshotChanges()
          .pipe(flatMap(clients => clients));
        snapshotResult.subscribe(doc => {
          this.existsEmail = doc.payload.doc.exists;
          this.user.push(
            doc.payload.doc.data(),
          );
        });
        console.log(this.existsEmail)
        if (this.existsEmail) {
          const user = await this.authSvc.register(email, password);
          if (user) {
            this.router.navigate(['/login']);
            console.log(user);
          }
        } else {
          this.isAlert = true;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async onCheckRegister() {
    try {
      const { email, password } = this.loginForm.value;
      const snapshotResult = this.firestore.collection('/Administradores', ref =>
        ref.where('email', '==', email))
        .snapshotChanges()
        .pipe(flatMap(clients => clients));
      snapshotResult.subscribe(doc => {
        this.existsEmail = doc.payload.doc.exists;
        this.user.push(
          doc.payload.doc.data(),
        );
      });
      console.log(this.existsEmail)
    } catch (error) {
      console.log(error);
    }
  }



  // async onLogin() {
  //   // const { email, password } = this.loginForm.value;
  //   try {
  //     const user = await this.authSvc.login(email, password);
  //     if (user) {
  //      console.log(user);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

}
